import { BaseRequest } from '@/network/requests/BaseRequest'
import { tech_xxx } from '@/interfaces/tech_xxx'

/**
 * 根据批次id获取工艺信息请求对象。
 * @param defectBatchId 批次id
 */
export const getTechRequest = (defectBatchId: string) => BaseRequest.build<tech_xxx>(`tech_${defectBatchId}`)
